import { render, staticRenderFns } from "./Roadmap2.vue?vue&type=template&id=06052667&scoped=true&"
import script from "./Roadmap2.vue?vue&type=script&lang=ts&"
export * from "./Roadmap2.vue?vue&type=script&lang=ts&"
import style0 from "./Roadmap2.vue?vue&type=style&index=0&id=06052667&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06052667",
  null
  
)

export default component.exports